export default request => ({
	get() {
		return request({
			path: "publisher",
			method: "get"
		});
	}
});
